<template>
  <div class="projects">
    <div class="banner">
      <div class="banner-warpper">
        <div class="container">
          <div class="banner-text">
            <h2>赛事中心</h2>
            <span class="subtitle"></span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="container">
      <div class="row">
        <form class="page-search-form" role="search">
          <div class="input-search input-search-dark">
            <input type="text" class="form-control" name="content" placeholder="输入关键字查询" />
          </div>
        </form>
      </div>
    </div>-->
    <div class="cats_area">
      <div v-if="cats0.length>0" class="nav-box" :style="cats0style">
        <template v-for="(catitem,index) in cats0">
          <a
            v-if="catitem"
            :key="index"
            href="javascript:;"
            class="needsclick nav-item selectCat"
            @click="selectCat(catitem)"
          >
            <img :src="`${catitem.cover}?x-oss-process=style/thumb`" class="nav-icon" />
            <div class="nav-name">
              <span :class="catId===catitem._id?'cat_selected':''">{{catitem.name}}</span>
            </div>
          </a>
          <a v-else :key="index" href="javascript:;" class="needsclick nav-item"></a>
        </template>
      </div>
      <div v-if="cats1.length>0" class="nav-box" :style="cats1style">
        <template v-for="(catitem,index) in cats1">
          <a
            v-if="catitem"
            :key="index"
            href="javascript:;"
            class="needsclick nav-item selectCat"
            @click="selectCat(catitem)"
          >
            <img :src="`${catitem.cover}?x-oss-process=style/thumb`" class="nav-icon" />
            <div class="nav-name">
              <span :class="catId===catitem._id?'cat_selected':''">{{catitem.name}}</span>
            </div>
          </a>
          <a v-else :key="index" href="javascript:;" class="needsclick nav-item"></a>
        </template>
      </div>
    </div>
    <div v-if="matches.length>0" class="container">
      <div class="box list-box row">
        <a
          v-for="(item,index) in matches"
          :key="index"
          :href="`https://xidong360.com/ssy_index/${item._id}`"
          class="needsclick item_a card-box m-t-9 col-lg-4 col-sm-6 col-xs-12"
        >
          <div
            class="item_pic"
            :style="{'background-image': `url('${item.cover}?x-oss-process=style/thumb')`}"
          >
            <div class="item_title_box">
              <div class="item_title">{{item.name}}</div>
            </div>
          </div>
          <div class="mes">
            <div class="navigator fix-listBox">
              <div class="navigator-text-box">
                <span class="navigator-text navigator-date-text">开始时间：{{item.sdate|dateTime}}</span>
                <span
                  class="navigator-price-text"
                  style="float:right;color:red;"
                  v-html="PRICE(item.price)"
                ></span>
              </div>
            </div>
          </div>
        </a>
        <p v-if="canloadMore" style="text-align:center;padding:10px;">
          <a
            href="javascript:;"
            class="next"
            style="text-decoration: underline;"
            @click="page++"
          >加载更多</a>
        </p>
      </div>
    </div>
    <div v-else class="error-box">暂无数据，稍后重试</div>
  </div>
</template>
<script>
import _ from "underscore";
export default {
  data() {
    return {
      cats: null,
      canloadMore: false,
      catId: "",
      page: 1,
      matches: [],
      catChanged: false,
    };
  },
  watch: {
    page() {
      this.getdata();
    },
  },
  computed: {
    cats0() {
      let cats = this.cats || [[], []];
      return cats[0];
    },
    cats0style() {
      let cats = this.cats || [[], []];
      return `flex-wrap: unset;width: calc( 20% * ${cats[0].length} );`;
    },
    cats1() {
      let cats = this.cats || [[], []];
      return cats[1];
    },
    cats1style() {
      let cats = this.cats || [[], []];
      return `flex-wrap: unset;width: calc( 20% * ${cats[1].length} );`;
    },
  },
  methods: {
    getcats() {
      this.$api
        .post("/wapi", {
          method: "ssy-app/match/getCats",
          data: {},
        })
        .then((res) => {
          if (res.code !== 0) return;
          this.cats = res.data;
        })
        .catch((err) => {});
    },
    getdata() {
      this.$api
        .post("/wapi", {
          method: "ssy-app/match/getList",
          data: {
            page: this.page,
            limit: 15,
            catId: this.catId,
          },
        })
        .then((res) => {
          if (res.code !== 0) return;
          this.canloadMore = res.data.canloadMore;
          if (this.matches.length === 0 || this.catChanged) {
            this.matches = res.data.data;
            if (this.catChanged) this.catChanged = false;
          } else {
            this.matches.push(...res.data.data);
          }
        })
        .catch((err) => {});
    },
    PRICE(price) {
      if (!price || price == "0") return "免费";
      return "&yen;" + price;
    },
    selectCat(catitem) {
      console.log(this.catId, catitem._id);
      if (this.catId !== catitem._id) {
        this.catId = catitem._id;
        this.catChanged = true;
        if (this.page === 1) this.getdata();
        else this.page = 1;
      }
    },
  },
  mounted() {
    this.getcats();
    this.getdata();
  },
};
</script>
  <style>
.cats_area {
  width: 100%;
  scroll-behavior: smooth;
  overflow-x: scroll;
}

.cats_area::-webkit-scrollbar {
  width: 0 !important;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
}

.cat_selected {
  border-bottom: 2px solid #ff8e35;
  color: #ff8e35;
}
</style>